export const baseUrl =
  process.env.NODE_ENV == 'development'
    ? 'https://guzellik.test/api/'
    : '/api/';

export const pageTitle = 'Güzellik Pro';
export const imageBase =
  process.env.NODE_ENV == 'development' ? 'https://guzellik.test/' : '/api/';
